import React from 'react';
import LoginScreen from '../../containers/LoginScreen';
import LightBox from './LightBox';

export default ({ loggedIn }) => (
  <>
    {
      loggedIn
        ? <LightBox />
        : <LoginScreen />
    }
  </>
);
